import { useState } from "react";
import FacetIcon from "./FacetIcon";

const EditionsFacet = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleFilterClick = (val) => {
    props.filtersHandler(props.id, val);
  };
  const checkIfActive = (f) => {
    if (!props.selections[props.id]) {
      return false;
    } else {
      return props.selections[props.id].includes(String(f));
    }
  };
  const getMonth = (weeknumber) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    const monthN = new Date(1000 * 60 * 60 * 24 * 7 * weeknumber).getMonth();
    return months[monthN];
  };
  return (
    <div className="w-full border-b-[1px] border-b-black border-dotted ">
      <div className="w-full flex flex-row justify-between items-center py-5">
        <span className="font-bold uppercase text-filter-title whitespace-nowrap">{props.label}</span>
        <span className={`transition-all duration-400 cursor-pointer ${isOpen ? '-rotate-45' : ''}`} onClick={() => setIsOpen(!isOpen)}><FacetIcon/></span>
      </div>
      {isOpen ? (
        <div className="flex flex-col items-start justif-start uppercase max-h-[150px] overflow-y-auto">
          {props.facetValues.map((f) => (
            <div
              className={`cursor-pointer hover:opacity-50 text-left ${
                checkIfActive(f.edition) ? "text-primary font-bold" : "text-grey"
              }`}
              onClick={() => handleFilterClick(f.edition)}
              key={f.edition}
            >
              {getMonth(f.week)} {f.year} #{f.edition}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default EditionsFacet;
